import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sidebar-open.tsx
/**
* icon.24.sidebar.open
*
* Keywords: panel, left, layout, split, navigation, frame, window, divide
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjY1MyA3LjAwOEExLjUgMS41IDAgMCAxIDE5IDguNXY3YTEuNSAxLjUgMCAwIDEtMS4zNDcgMS40OTJMMTcuNSAxN2gtMTFhMS41IDEuNSAwIDAgMS0xLjQ5Mi0xLjM0N0w1IDE1LjV2LTdBMS41IDEuNSAwIDAgMSA2LjUgN2gxMXpNNi41IDhhLjUuNSAwIDAgMC0uNS41djdhLjUuNSAwIDAgMCAuNS41SDlWOHptMy41IDhoNy41YS41LjUgMCAwIDAgLjUtLjV2LTdhLjUuNSAwIDAgMC0uNS0uNUgxMHoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-991
*/
const Icon24SidebarOpen = memo(function Icon24SidebarOpen(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.653 7.008A1.5 1.5 0 0 1 19 8.5v7a1.5 1.5 0 0 1-1.347 1.492L17.5 17h-11a1.5 1.5 0 0 1-1.492-1.347L5 15.5v-7A1.5 1.5 0 0 1 6.5 7h11zM6.5 8a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H9V8zm3.5 8h7.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H10z"
		})
	});
});
//#endregion
export { Icon24SidebarOpen };

//# sourceMappingURL=icon-24-sidebar-open.js.map